export const springboard = {
  dashboard: {
    assetReviews: {
      assetsAwaitingApproval: 'Assets awaiting approval',
      assetCount_one: '{{count}} asset',
      assetCount_other: '{{count}} assets',
      displayedPerFolder: 'Displayed per folder',
      projectTag: '#{{projectTitle}}',
      untitledProject: 'Untitled project',
    },
    audienceSparks: {
      contentComingSoon: 'Content coming soon...',
      nextSparks: 'Next sparks',
      previousSparks: 'Previous sparks',
      sparksFromAudience: 'Sparks from audience',
      sparksFromTheAudience: 'Sparks from the audience',
    },
    dashboardGreeting: {
      greetingLine: '{{greeting}} {{userName}},',
      whatDoYouWantTo: 'What do you want to work on today?',
    },
    editingShortcutSlot: {
      addTitle: 'Add shortcut',
      cancel: 'Cancel',
      confirm: 'Confirm',
      editTitle: 'Edit shortcut',
      selectTool: 'Select tool',
    },
    emptyShortcutSlot: {
      addShortcut: 'Add shortcut',
      fillThePreviousSlotFirst: 'Fill the previous slot first',
    },
    filledShortcutSlot: {
      edit: 'Edit',
      launch: 'Launch',
      remove: 'Remove',
      shortcutActions: 'More actions',
      toolUnavailable: 'Tool unavailable',
    },
    greetingV2: {
      goodAfternoon: 'Good afternoon',
      goodEvening: 'Good evening',
      goodMorning: 'Good morning',
      greetingLine: '{{greeting}}, {{userName}}',
      monksFlowLogo: 'Monks Flow Logo',
    },
    mostUsedTools: {
      contactYourOrganizationAdminTo:
        'Contact your organization admin to request tools access for this workspace.',
      mostUsedTools: 'Most used tools',
      notConfigured: 'Not Configured',
      noToolAvailable: 'No tool available',
      thisToolNeedsToBe: 'This tool needs to be configured by an administrator',
    },
    opportunitiesEmptyState: {
      allYourFavoriteOpportunitiesWill:
        'All your favorite opportunities will be displayed here once you add them',
      noFavoriteOpportunityAddedYet: 'No favorite opportunity added yet',
      noOpportunityGeneratedRecently: 'No opportunity generated recently',
      opportunitiesWillAppearHereAs: 'Opportunities will appear here as you engage with agents',
    },
    opportunitiesPreview: {
      allOpportunities: 'All opportunities',
      noOpportunitiesYet: 'No opportunities yet',
      opportunities: 'Opportunities',
      rankedByShorterDuration: 'Ranked by opportunities with shorter duration',
    },
    personaEmptyState: {
      noAudiencesCreatedYet: 'No audiences created yet',
      reachOutToYourAccount:
        'Reach out to your account admin and request this feature to start visualizing daily sparks and insights',
    },
    personaSpark: {
      todaySSparkFromYour: "Today's spark from your audience",
    },
    recentOpportunities: {
      highlightedOpportunities: 'Highlighted Opportunities',
      seeAll: 'See all',
    },
    recentSessions: {
      recentSessions: 'Recent sessions',
      seeAll: 'See all',
      session: 'Session',
      untitledSession: 'Untitled session',
    },
    springboardCards: {
      create: 'Create',
      createDescription: 'Build smart. Craft faster.',
      deliver: 'Deliver',
      deliverDescription: 'Launch clean. Move faster.',
      plan: 'Plan',
      planDescription: 'See ahead. Shape strategy.',
      scale: 'Scale',
      scaleDescription: 'Learn fast. Grow faster.',
    },
    recentProjects: {
      allProjects: 'All projects',
      lastActivity: 'Last activity {{date}}',
      recentProjects: 'Recent projects',
      untitledProject: 'Untitled project',
    },
    springboard: {
      browseToolsByCategories: 'Browse tools by categories',
    },
    toolShortcuts: {
      contentTest: 'Content Test',
      focusGroups: 'Focus Groups',
      toolShortcuts: 'Tool shortcuts',
    },
    useToolShortcuts: {
      couldNotRemoveTheShortcut: 'Could not remove the shortcut',
      couldNotSaveTheShortcut: 'Could not save the shortcut',
      yourShortcutsWereRefreshed: 'Your shortcuts were refreshed to match the server.',
    },
  },
  download: {
    documentNotFound: 'Document not found.',
    notFound: 'Not found.',
  },
  nacb: {
    nacbintakeFormPage: {
      anUnexpectedErrorOccurred: 'An unexpected error occurred',
      brand: 'Brand',
      cancel: 'Cancel',
      enterYourName: 'Enter your name',
      fast12DayTurnaround: 'Fast (1–2 day turnaround)',
      high: 'High',
      howWouldYouClassifyThe:
        'How would you classify the level of involvement (order of magnitude)?',
      low: 'Low',
      medium: 'Medium',
      nacbTriggerIntakeForm: 'NACB Trigger Intake Form',
      name: 'Name',
      notUrgent12Months: 'Not urgent (1–2 months)',
      opportunistic1Week: 'Opportunistic (~1 week)',
      other: 'Other',
      pleaseEnterAtMost400: 'Please enter at most 400 characters',
      pleaseSelectTheDesiredTurnaround:
        'Please select the desired turnaround timeframe for this request',
      required: 'Required',
      selectABrand: 'Select a brand',
      submitRequest: 'Submit Request',
      submitting: 'Submitting',
      useThisFormToTrigger: 'Use this form to trigger an unplanned request to Agency partners',
      whatBusinessSituationSocialOr:
        'What business situation, social or cultural insight, or content/asset gap (in 50 words or less) triggered the need for this initiative?',
      whenYouSubmitThisForm:
        'When you submit this form, it will not automatically collect your details like name and email address unless you provide it yourself.',
    },
  },
  springboard: {
    overview: 'Overview',
    smartCardMock: {
      createAiImages: 'Create AI Images',
      createAMarketingStrategy: 'Create a Marketing Strategy',
      generateMarketingCopy: 'Generate Marketing Copy',
      translateAdCopyForGlobal: 'Translate Ad Copy for Global Use',
    },
    smartStartGridV4: {
      failedToLoadSmartStart: 'Failed to load smart start cards. Please try again later.',
      noSmartStartCardsAvailable: 'No smart start cards available for this section.',
    },
    smartStarts: 'Smart Starts',
    tabs: {
      create: 'Create',
      createDescription:
        'Make sense of the messy. Turn raw thoughts into clear strategy. Generate insights, define priorities, and move forward with confidence.',
      createSubtitle: 'Build smart. Craft faster.',
      deliver: 'Deliver',
      deliverDescription:
        'Launch work seamlessly, keep everything running smoothly, and make quick optimizations as your campaign goes live.',
      deliverSubtitle: 'Launch clean. Move faster.',
      plan: 'Plan',
      planDescription:
        'Make sense of the messy. Turn raw thoughts into clear strategy. Generate insights, define priorities, and move forward with confidence.',
      planSubtitle: 'See ahead. Shape strategy.',
      scale: 'Scale',
      scaleDescription:
        'Turn your strongest ideas into repeatable growth. Optimize performance, automate what works, and keep momentum high across every market.',
      scaleSubtitle: 'Learn fast. Grow faster.',
      support: 'Support',
      supportDescription:
        'Never get stuck. Connect instantly with support agents, access step-by-step guidance, and explore training videos whenever you need them.',
      supportSubtitle: 'Get help. Keep moving.',
      supportToolsTitle: 'Tools to learn more or get support',
    },
    toolGrid: {
      notConfigured: 'Not Configured',
    },
    toolGridV4: {
      digestFlowAnalysisAndReporting: 'Digest flow analysis and reporting',
      failedToLoadTools: 'Failed to load tools',
      notConfigured: 'Not Configured',
      noToolsAvailable: 'No tools available',
      pleaseContactYourAdministratorTo: 'Please contact your administrator to request access.',
      pleaseTryAgainLater: 'Please try again later.',
      scaleVariationsAcrossMarkets: 'Scale variations across markets',
      spotTimelyBrandSafeOpportunities: 'Spot timely, brand-safe opportunities',
      thisToolNeedsToBe: 'This tool needs to be configured by an administrator',
    },
    tools: 'Tools',
    toolsTo: 'Tools to {{label}}',
    useSaveSpringboardCategories: {
      couldNotSaveCustomization: 'Could not save customization',
    },
    useSpringboardTools: {
      untitledTool: 'Untitled Tool',
    },
  },
} as const;
